class Transform {

  formatPhoneNumber(phoneNumber) {
    // Remove all non-numeric characters
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');

    // Match cleaned number to format: (XXX) XXX-XXXX
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }

    return phoneNumber; // Return the original input if it doesn't match the format
  }

  transformToAPIFormat(selectedOptions) {
    return {
      selectedInspectionOptions: Object.keys(selectedOptions).map(key => {
        const option = selectedOptions[key];
        const transformedOption = {
          name: key,
          rating: option.rating,
          comments: option.comments,
          inspectionSubQueries: []
        };

        if (option.inspectionSubQueries) {
          transformedOption.inspectionSubQueries.push({
            name: option.inspectionSubQueries.name,
            selectType: option.inspectionSubQueries.selectType,
            ratings: option.inspectionSubQueries.ratings
          });
        }

        if (option.inspectionSubQueriesText) {
          transformedOption.inspectionSubQueries.push({
            name: option.inspectionSubQueriesText.name,
            selectType: "Open text",
            ratings: option.inspectionSubQueriesText.ratings
          });
        }

        return transformedOption;
      })
    };
  }
}

export default new Transform();
